export default __webpack_public_path__ + "static/media/person.62bc4755.svg";